export const CSS = {
  list: "list",
  label: "label",
  title: "title",
};
